import * as React from 'react';
import { Link } from 'react-router-dom';
import './Campaigns.css';
import * as controller from '../campaign/controller'
import * as Moment from 'moment-timezone'
import { withLocalize } from "react-localize-redux";

class Campaigns extends React.Component<any, any> {
  removeCampaign: any
  constructor(props: any) {
    super(props);
    this.state = {
      campaigns: []
    }
    this.loadCampaigns = this.loadCampaigns.bind(this)
    this.removeCampaign = controller.removeCampaign.bind(this)
  }


  loadCampaigns() {
    fetch('campaigns/getAll', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let campaigns = data.campaigns
        this.setState({campaigns})
    }).catch(err => {
      alert(err.message);
    })
  }

  componentDidMount() {

  }

  componentWillMount() {
    this.loadCampaigns()
  }

  componentWillUnmount() {
  }

  renderCampaigns = () => {
    let campaigns = []
    let account = window.account
    for (let i = 0; i < this.state.campaigns.length; i++) {
      let campaign = Object.assign({},this.state.campaigns[i]) //Doing this to prevent editing the tasks in the view
      campaigns.push(
        <div key={i} className="campaign">
          {account.type == "admin" && account.privilege == "admin" && <i onClick={this.removeCampaign.bind(this, campaign.id, i)} className="fas fa-trash"></i>}
          <Link to={"/campaigns/"+campaign.id+"/stats"}><i className="fas fa-chart-line"></i></Link>
          <div className="id">{campaign.id}</div>
          {campaign.logo.length? (
            <div className="logo" style={{backgroundImage: "url("+process.env.REACT_APP_AWS+"/campaigns/"+campaign.id+"/logos/"+campaign.logo+")"}}></div>
          ) : (
            <div className="logo"></div>
          )}
          <Link to={"/campaigns/"+campaign.id} ><h4>{campaign.title}</h4></Link>
          <span className="dates"><i className="fas fa-clock"></i>{Moment.tz(campaign.startDate, process.env.REACT_APP_TIMEZONE || "").format("DD/MM/YYYY")} - {Moment.tz(campaign.endDate, process.env.REACT_APP_TIMEZONE || "").format("DD/MM/YYYY")}</span>
          <span className="counter"><i className="fas fa-users"></i>{campaign.participating}/{campaign.maxUsers}</span>
          {window.account.type == "admin" && <span className="totalPrice"><i className="fas fa-money-bill-alt"></i>₪{campaign.totalPrice}</span>}
        </div>
      )
    }
    return campaigns
  }

  public render() {
    return (
      <div id="tasks-root">

        <div className="board">
          {this.renderCampaigns()}
        </div>

      </div>
    )
  }

}

export default withLocalize(Campaigns)



// WEBPACK FOOTER //
// ./src/pages/campaigns/Campaigns.tsx